import type { UseBulkActionToolbarComposable } from './epb-bulk-actions.types'
import { inject } from 'vue'
import { BULK_ACTION_PROVIDER_KEY } from './consts'

export function useBulkActionToolbar<T>(): UseBulkActionToolbarComposable<T> {
  return (
    inject<UseBulkActionToolbarComposable<T>>(BULK_ACTION_PROVIDER_KEY) ??
    ({} as UseBulkActionToolbarComposable<T>)
  )
}
